export const FirebaseConfig = {
	"projectId": "bitride-41c11",
	"appId": "1:890201929479:web:7bbde55eefcd9c366277a2",
	"databaseURL": "https://bitride-41c11-default-rtdb.firebaseio.com",
	"storageBucket": "bitride-41c11.firebasestorage.app",
	"locationId": "asia-south1",
	"apiKey": "AIzaSyBSBhsQ6wv6r35hL0-hEDWmKVOo94Tk7kM",
	"authDomain": "bitride-41c11.firebaseapp.com",
	"messagingSenderId": "890201929479",
	"measurementId": "G-DWPS3QF3G2",
	"projectNumber": "890201929479",
	"version": "2"
};